
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/detention-handling",
      function () {
        return require("private-next-pages/ai/detention-handling.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/detention-handling"])
      });
    }
  